import React from 'react'
import { ICellRendererParams } from 'ag-grid-community'
import { IdeyaButton } from '../../../common/antd/ideya-button'
import { FirmData } from '../../../apis/firm-management/firm-management-api.def'
import { useDispatch } from 'react-redux'
import {
  setAccountFirm,
  setAccountType,
} from '../../../redux/slices/management-input.slice.ts'
import { useNavigate } from 'react-router-dom'

type UserButtonCellProps = ICellRendererParams<FirmData>

export const UserButtonCell: React.FC<UserButtonCellProps> = ({ data }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  if (!data) return <></>

  const handleClick = () => {
    dispatch(setAccountType(data.type))
    dispatch(setAccountFirm(data.id))
    navigate('/account-management/user')
  }

  return (
    <IdeyaButton ideyaType={'secondary'} onClick={handleClick}>
      User
    </IdeyaButton>
  )
}
